export default __webpack_public_path__ + "static/media/garbage-1.06ae877b.svg";